import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/joy';
import { Button } from '../Button';
import { Text } from '../Typography';

const Confirm = ({ title, oklabel = "OK", okcallable, kolabel = "NO", kocallable, children }) => {
    const [submitting, setSubmitting] = useState(false)
    const mountedRef = useRef(true)

    useEffect(() => {
        return () => {
            mountedRef.current = false
        }
    }, [])

    const handleOk = () => {
        if (submitting) return
        const ret = okcallable?.()
        if (ret != null && typeof ret.then === 'function') {
            setSubmitting(true)
            ret.finally(() => {
                if (mountedRef.current) setSubmitting(false)
            })
        }
    }

    return (
        <Box className="dialog dialog-confirm">
            <Box className="dialog-backdrop"></Box>
            <Box className="dialog-content">
                {(title && (
                    <Text level="h3">{title}</Text>
                ))}

                <Text level="body-md">{children}</Text>

                <Box className="dialog-actions">
                    <Button variant="soft" className="dialog-ko" onClick={kocallable} disabled={submitting}>{kolabel}</Button>
                    <Button variant="solid" className="dialog-ok" onClick={handleOk} loading={submitting} disabled={submitting}>{oklabel}</Button>
                </Box>
            </Box>
        </Box>
    )

}

export default Confirm;
